export const CREATE_PROFILE = 'profiles/create';
export const RETRIEVE_PROFILES = 'profiles/retrieve';
export const RETRIEVE_PROFILES_LIST = 'profiles/retrieve/list';
export const RETRIEVE_ORGANIZATIONS_LIST = 'organizations/retrieve/list';
export const RETRIEVE_PROFILE = 'profiles/getById';
export const UPDATE_PROFILE = 'profiles/update';
